module.exports = __webpack_public_path__ + "img/5.fda355cf.jpg";